import * as React from 'react';
import { useSelector } from 'react-redux';
import { getSpecialPromos } from '../../selectors/developerV2';
import { PromosPreview } from '../../components/PromosPreview';
import { PromoIconContainer } from './parts/PromoIcon';
import { TPromoType } from '../../types/specialPromos/specialPromos';
import { trackClickSpecialPromosMobile } from '../SpecialPromoRedesign/tracking';

export function SpecialPromosPreviewContainer() {
  const specialPromos = useSelector(getSpecialPromos);

  const promosPreview = specialPromos?.promosPreview;
  const promosPageLink = specialPromos?.promosPageLink;

  /* istanbul ignore next */
  if (!promosPreview) {
    return null;
  }

  const props = {
    title: promosPreview.title,
    morePromos: promosPreview.morePromosCount,
    morePromosLink: promosPageLink as string,
  };

  const promoItems = promosPreview.promoTypes.map(type => <PromoIconContainer key={type} type={type as TPromoType} />);

  return <PromosPreview {...props} promoItems={promoItems} onClick={trackClickSpecialPromosMobile} />;
}
